module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "14px",
      "padding-bottom": "0px",
      "position": "relative"
    }
  }, [_c('md-dialog-content', [_c('button', {
    staticStyle: {
      "background": "none",
      "border": "none",
      "position": "absolute",
      "top": "0px",
      "right": "0px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.closeDialogModel
    }
  }, [_c('md-icon', [_vm._v("close")])], 1), _vm._v(" "), _c('p', [_vm._v("Create Your Project")]), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "project-name"
    }
  }, [_vm._v("Project Name")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.project.title),
      callback: function($$v) {
        _vm.$set(_vm.project, "title", $$v)
      },
      expression: "project.title"
    }
  }), _vm._v(" "), (_vm.titleError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.titleError))]) : _vm._e()], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "file"
    }
  }, [_vm._v("File")]), _vm._v(" "), _c('md-file', {
    ref: "fileproject",
    staticClass: "file-input",
    attrs: {
      "required": "",
      "accept": "application/pdf"
    },
    on: {
      "selected": _vm.onFileChange
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "your-role"
    }
  }, [_vm._v("Your role")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.project.ownerRole),
      callback: function($$v) {
        _vm.$set(_vm.project, "ownerRole", $$v)
      },
      expression: "project.ownerRole"
    }
  }), _vm._v(" "), (_vm.roleError) ? _c('span', {
    staticClass: "md-error"
  }, [_vm._v(_vm._s(_vm.roleError))]) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-16c47366","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/create-project/create.vue
// module id = 1206
// module chunks = 21